"use strict";

import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

export default function dragScroll() {
    document.querySelectorAll(".c-blog-filter.swiper").forEach((el) => {
        new Swiper(el, {
            modules: [FreeMode],
            slidesPerView: "auto",
            spaceBetween: 8,
            freeMode: true,
            grabCursor: true,
            preventClicks: true,
            preventClicksPropagation: false,
            touchStartPreventDefault: false,
        });
    });
}
